import React from 'react';

const Features = () => {
  // Feature data
  const features = [
    {
      id: 1,
      title: "AI-Powered Network",
      description: "Our devices utilize artificial intelligence to optimize connectivity and maximize network efficiency in real-time.",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="2"/>
          <path d="M7.5 12H16.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M12 6.5V17.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )
    },
    {
      id: 2,
      title: "Global Connectivity",
      description: "Access high-speed internet anywhere in the world while earning passive income through our mining ecosystem.",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 9V3H15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 15V21H9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 3L14 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 14L3 21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      id: 3,
      title: "RWA Mining System",
      description: "Our unique Real World Asset mining system bridges physical hardware with digital rewards through the AFI token.",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="white" strokeWidth="2"/>
          <path d="M19.0711 19.0711C16.7713 21.3709 13.4853 22.5 10 22.5C6.51472 22.5 3.22876 21.3709 0.928932 19.0711C-1.37085 16.7713 -2.5 13.4853 -2.5 10C-2.5 6.51472 -1.37085 3.22876 0.928932 0.928932C3.22876 -1.37085 6.51472 -2.5 10 -2.5C13.4853 -2.5 16.7713 -1.37085 19.0711 0.928932C21.3709 3.22876 22.5 6.51472 22.5 10C22.5 13.4853 21.3709 16.7713 19.0711 19.0711Z" stroke="white" strokeWidth="2"/>
          <path d="M17.301 17.301C15.7751 18.827 13.6965 19.75 11.5 19.75C9.30353 19.75 7.22487 18.827 5.69903 17.301C4.17319 15.7751 3.25 13.6965 3.25 11.5C3.25 9.30353 4.17319 7.22487 5.69903 5.69903C7.22487 4.17319 9.30353 3.25 11.5 3.25C13.6965 3.25 15.7751 4.17319 17.301 5.69903C18.827 7.22487 19.75 9.30353 19.75 11.5C19.75 13.6965 18.827 15.7751 17.301 17.301Z" stroke="white" strokeWidth="2"/>
        </svg>
      )
    },
    {
      id: 4,
      title: "Staking Rewards",
      description: "Enhance your mining profits by staking AFI tokens with your device, unlocking higher yield tiers and bonuses.",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" strokeWidth="2"/>
        </svg>
      )
    },
    {
      id: 5,
      title: "Sustainable Tokenomics",
      description: "Our carefully balanced token model creates long-term value with device revenue mapping to ensure sustainable growth.",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7L12 3L4 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 7V17L12 21L20 17V7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11L20 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11L4 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
  id: 6,
  title: "Privacy Network",
  description: "Achieve global information encryption through the AeroNyx Privacy SDK, operating as mobile onion-routing nodes.",
  icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L19 6V18L12 22L5 18V6L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 2V8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16V22" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 6L12 10L20 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <h2 className="section-title">Revolutionary <span>Web3 Technology</span></h2>
        <p className="section-subtitle">Aledger combines portable WiFi hardware with blockchain rewards to create a sustainable ecosystem that grows with every connected device.</p>
        
        <div className="features-grid">
          {features.map(feature => (
            <div className="feature-card" key={feature.id}>
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
